// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2QbFQ","amount":"Amount_amount__TJexC","tip":"Amount_tip__QYSs5","tipHeader":"Amount_tipHeader__1LQQk","tipsWrap":"Amount_tipsWrap__3HH-M"};